var _path, _ellipse, _circle, _path2, _ellipse2, _circle2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBadPack6 = function SvgBadPack6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 270 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 69.888c55.284 13.621 40.395 54.417 26.039 73.112 16.025 21.633-1.335 35.721-12.018 40.061-9.615 53.682-52.747 43.734-73.112 32.049-28.844 4.808-42.064-14.689-45.069-25.038-36.856-6.41-36.722-37.39-32.049-52.079-25.639-42.465 10.683-63.097 32.05-68.105 13.62-37.657 45.736-24.37 60.091-13.02 20.832-14.422 38.058 2.671 44.068 13.02Z",
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.315,
    cy: 116.261,
    rx: 20.838,
    ry: 27.784,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104.315,
    cy: 116.261,
    r: 6.946,
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m80.927 117.258 43.412-11.416",
    stroke: "#000",
    strokeWidth: 5.904,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.838,
    cy: 27.784,
    rx: 20.838,
    ry: 27.784,
    transform: "matrix(-1 0 0 1 181.645 88.478)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.946,
    cy: 6.946,
    r: 6.946,
    transform: "matrix(-1 0 0 1 167.753 109.315)",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m184.195 117.258-43.412-11.416",
    stroke: "#000",
    strokeWidth: 5.904,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.752 135.363v12.155m8.682-19.101v26.047",
    stroke: "#fff",
    strokeWidth: 5.904,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.771 156.27c-8.986 0-9.362 9.36-9.361 13.104-.001 3.744.375 12.875 9.361 11.962 11.232-1.141 9.359-4.474 20.591-4.474 11.231 0 9.36 5.616 22.463 5.616 13.104 0 11.232-28.08 0-28.08s-11.232 7.488-22.463 7.488c-11.232 0-9.36-5.616-20.591-5.616Z",
    stroke: "#fff",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.493 145.983c-4.675 19.635-.842 57.784 51.894 53.296m0 0v-8.415m0 8.415 8.416-8.415m-8.416 8.415 15.428-4.208m-15.428 4.208 12.623 1.403m-12.623-1.403 2.805 4.208M212.113 154.398c4.675 19.635.841 57.784-51.894 53.296m0 0-.001-8.415m.001 8.415-8.416-8.415m8.416 8.415-15.429-4.207m15.429 4.207-12.624 1.403m12.624-1.403-2.806 4.208",
    stroke: "#000",
    strokeWidth: 1.964,
    strokeLinecap: "round"
  })));
};
export default SvgBadPack6;